import {
  BankAccount,
  BankAccountEditReason,
  BankStatementMonthlySummary,
  NewBankAccount
} from 'app/models/dto/bank-account.model';

export class GetBankAccountValues {
	static readonly type = '[BankAccount] GetBankAccountValues';
	constructor(public borrowerId: number) {}
}

export class ClearBankAccountValues {
	static readonly type = '[BankAccount] ClearBankAccountValues';
	constructor(public borrowerId: number) {}
}

export class AddBankAccount {
	static readonly type = '[BankAccount] AddBankAccount';
	constructor(public newBankAccount: NewBankAccount) {}
}

export class EditBankAccount {
	static readonly type = '[BankAccount] EditBankAccount';
	constructor(public bankAccount: BankAccount, public borrowerId: number) {}
}

export class CloneBankAccount {
	static readonly type = '[BankAccount] CloneBankAccount';
	constructor(public bankAccountId: number, public borrowerId: number) {}
}

export class RemoveBankAccount {
	static readonly type = '[BankAccount] RemoveBankAccount';
	constructor(public bankAccountId: number, public borrowerId: number) {}
}

export class EditBankStatementMonthlySummaries {
	static readonly type = '[BankAccount] EditBankStatementMonthlySummaries';
	constructor(public summaries: BankStatementMonthlySummary[], public borrowerId: number) {}
}

export class EditBankStatementMonthlySummariesReason {
  static readonly type = '[BankAccount] EditBankStatementMonthlySummariesReason';
  constructor(public borrowerId: number, public bankAccountEditReason: BankAccountEditReason) {}
}

export class EditBankAccountAndSummaries {
	static readonly type = '[BankAccount] EditBankAccountAndSummaries';
	constructor(public bankAccount: BankAccount, public borrowerId: number) {}
}

export class CreateBankStatementMonthlySummary {
	static readonly type = '[BankAccount] CreateBankStatementMonthlySummary';
	constructor(public summary: BankStatementMonthlySummary, public borrowerId: number) {}
}

export class AcknowledgeOcrolusErrors {
	static readonly type = '[BankAccouynt] AcknowledgeOcrolusErrors';
	constructor(public borrowerId: number) {}
}

export class PullSummariesSync {
  static readonly type = '[BankAccount] PullSummariesSync';
  constructor(public borrowerId: number) {}
}
